import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import ConversationDetail from "../../../components/common/Communication/ConversationDetail";
import MessageWrapper from "../../../components/common/Communication/MessageWrapper";
import { useGetOneToOneChatListQuery } from "../../../features/superAdmin/ticketService/ticketServiceApi";
import useError from "../../../hooks/useError";
import SidebarLayout from "../../../layouts/SidebarLayout";

export default function MessageDetails() {
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");
  const auth = useAppSelector((state) => state.auth);
  const [searchParams] = useSearchParams();
  const leave = searchParams.get("leave");
  const scrollTopRef = useRef<HTMLDivElement | null>(null);
  const {
    data: oneToOneChatListData,
    isError,
    error,
    refetch,
    isLoading,
  } = useGetOneToOneChatListQuery(
    {
      params: {
        id: auth.user?.id || "",
        search: search,
        type: type,
      },
    },
    { skip: !auth.user?.id },
  );

  useError(isError, error, "Get chat list failed");

  useEffect(() => {
    if (leave === "true") {
      try {
        refetch();
      } catch (err) {}
    }
  }, [leave, refetch]);

  const handleRefetch = () => {
    if (auth.user?.id && refetch) {
      try {
        refetch();
      } catch (err) {}
    }
  };

  const scrollToTop = () => {
    scrollTopRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToTop();
  }, [oneToOneChatListData]);

  return (
    <SidebarLayout title="Message">
      <MessageWrapper
        isLoading={isLoading}
        oneToOneChatListData={oneToOneChatListData}
        setSearch={setSearch}
        setType={setType}
        type={type}
      >
        <ConversationDetail
          refetch={handleRefetch}
          topUserId={oneToOneChatListData?.data?.[0]?.connectedUser?.id!}
        />
      </MessageWrapper>
    </SidebarLayout>
  );
}
